import React from "react";
// Import your shared formatting component
import FormattedText from "../../Utility/FormattedText"; 

const GrammarErrorCard = ({ item }) => {
  return (
    <div className="w-full max-w-4xl mx-auto mt-4">
      <div className="border border-gray-300 p-4 rounded-lg bg-white shadow-sm">
        <h3 className="font-semibold text-lg mb-3">Grammar Correction</h3>

        {/* Wrong Section */}
        <div className="mb-3">
          <div className="text-xs font-semibold text-gray-700 mb-1 uppercase tracking-wide">
            Wrong
          </div>
          {/* Using FormattedText with Red styling */}
          <div className="text-red-600 font-semibold break-words">
            <FormattedText text={item.wrong_text} />
          </div>
        </div>

        {/* Correct Section */}
        <div>
          <div className="text-xs font-semibold text-gray-700 mb-1 uppercase tracking-wide">
            Correct
          </div>
          {/* Using FormattedText with Blue styling */}
          <div className="text-blue-600 font-semibold break-words">
            <FormattedText text={item.correct_text} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GrammarErrorCard;